import React, { useState } from 'react';

const Input = ({
  type = 'text',
  placeholder = '',
  value,
  onChange,
  label = '',
  error = '',
  required = false,
  disabled = false,
  icon = null,
  name = '',
  autoComplete = 'off',
  canPeekPassword = false,
  onFocus,
  onBlur
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const resolvedType = canPeekPassword && type === 'password' && isPasswordVisible ? 'text' : type;

  const containerStyle = {
    marginBottom: '0px',
    width: '100%'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '6px'
  };

  const inputWrapperStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  };

  const inputStyle = {
    width: '100%',
    padding: canPeekPassword && type === 'password'
      ? (icon ? '12px 48px 12px 40px' : '12px 48px 12px 12px')
      : (icon ? '12px 12px 12px 40px' : '12px'),
    fontSize: '14px',
    border: `1px solid ${error ? '#ef4444' : 'var(--border)'}`,
    borderRadius: '8px',
    background: 'var(--surface)',
    color: 'var(--text-primary)',
    outline: 'none',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit'
  };

  const iconStyle = {
    position: 'absolute',
    left: '12px',
    color: 'var(--text-secondary)',
    display: 'flex',
    alignItems: 'center'
  };

  const errorStyle = {
    fontSize: '12px',
    color: '#ef4444',
    marginTop: '4px'
  };

  const peekButtonStyle = {
    position: 'absolute',
    right: '12px',
    border: 'none',
    background: 'transparent',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <div style={containerStyle}>
      {label && (
        <label style={labelStyle}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </label>
      )}
      <div style={inputWrapperStyle}>
        {icon && <span style={iconStyle}>{icon}</span>}
        <input
          type={resolvedType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          name={name}
          autoComplete={autoComplete}
          style={inputStyle}
          onFocus={(e) => {
            e.target.style.borderColor = error ? '#ef4444' : 'var(--primary)';
            e.target.style.boxShadow = error 
              ? '0 0 0 3px rgba(239, 68, 68, 0.1)' 
              : '0 0 0 3px var(--primary-light)';
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            e.target.style.borderColor = error ? '#ef4444' : 'var(--border)';
            e.target.style.boxShadow = 'none';
            onBlur && onBlur(e);
          }}
        />
        {canPeekPassword && type === 'password' && (
          <button
            type="button"
            style={peekButtonStyle}
            onClick={() => setIsPasswordVisible((prev) => !prev)}
          >
            {isPasswordVisible ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
              <line x1="1" y1="1" x2="23" y2="23" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          )}
          </button>
        )}
      </div>
      {error && <div style={errorStyle}>{error}</div>}
    </div>
  );
};

export default Input;